import { Type } from '@angular/core';
import { SendEmailPreviewComponent } from './send-email-preview/send-email-preview.component';
import { ContinueExecutionPreviewComponent } from './continue-execution-preview/continue-execution-preview.component';

/**
 * Registry mapping action types to their preview components
 */
export const ACTION_PREVIEW_REGISTRY: { [key: string]: Type<any> } = {
  'send_email': SendEmailPreviewComponent,
  'continue_execution': ContinueExecutionPreviewComponent,
  // Add more action type mappings here as needed
  // 'create_deal': CreateDealPreviewComponent,
  // 'update_record': UpdateRecordPreviewComponent,
};

/**
 * Get the preview component for a given action type
 */
export function getPreviewComponent(actionType: string): Type<any> | null {
  return ACTION_PREVIEW_REGISTRY[actionType] || null;
}
